export default __webpack_public_path__ + "static/media/charts1.38b70164.png";